module.exports = __webpack_public_path__ + "img/import-automatically.736fe1c.svg";